import React from 'react';
import { Shield, Zap, Target, Eye, Waves, Lock } from 'lucide-react';
import '../styles/Project.css';

const Project = () => {
  const features = [
    {
      icon: <Shield size={32} />,
      title: 'Gizli Algılama',
      description: 'Kendi sinyali yayınlamadan çevredeki mevcut RF sinyallerini kullanarak hedefleri tespit eder.'
    },
    {
      icon: <Zap size={32} />,
      title: 'Düşük Maliyet',
      description: 'Geleneksel radarlara kıyasla önemli ölçüde daha düşük kurulum ve işletme maliyeti sunar.'
    },
    {
      icon: <Target size={32} />,
      title: 'Yüksek Hassasiyet',
      description: 'Gelişmiş sinyal işleme algoritmaları ile yüksek doğrulukta hedef tespiti ve takibi sağlar.'
    },
    {
      icon: <Eye size={32} />,
      title: 'Geniş Kapsama',
      description: 'Birden fazla frekans bandını aynı anda kullanarak geniş bir alan kapsamı sunar.'
    },
    {
      icon: <Waves size={32} />,
      title: 'Çok Yönlü Kullanım',
      description: 'Havacılık, savunma, güvenlik ve sivil uygulamalar için uyarlanabilir sistem.'
    },
    {
      icon: <Lock size={32} />,
      title: 'Güvenli Operasyon',
      description: 'Düşük elektromanyetik iz ile güvenli ve sürdürülebilir operasyonel kullanım.'
    }
  ];

  return (
    <section id="project" className="project-section">
      <div className="project-container">
        <div className="project-header">
          <div className="section-badge">
            <span>PROJE</span>
          </div>
          <h2 className="section-title display-large">Pasif Radar Nedir?</h2>
          <p className="section-description body-medium">
            Pasif radar, kendi RF (Radyo Frekansı) sinyali yayınlamak yerine, çevredeki mevcut 
            sinyalleri (TV, radyo vb.) kullanarak hedefleri tespit 
            eden yenilikçi bir teknolojidir. Bu yaklaşım, sistemin elektromanyetik izini minimize 
            ederek gizli operasyonları mümkün kılar ve operasyonel maliyetleri önemli ölçüde düşürür.
          </p>
        </div>
        
        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-card dark-hover">
              <div className="feature-icon">
                {feature.icon}
              </div>
              <h3 className="feature-title heading-3">{feature.title}</h3>
              <p className="feature-description body-small">{feature.description}</p>
            </div>
          ))}
        </div>
        
        <div className="project-tech-info">
          <h3 className="heading-2">Teknik Özellikler</h3>
          <div className="tech-grid">
            <div className="tech-item">
              <div className="tech-label body-muted">Frekans Aralığı</div>
              <div className="tech-value body-medium">VHF, UHF ve üzeri bantlar</div>
            </div>
            <div className="tech-item">
              <div className="tech-label body-muted">Algılama Menzili</div>
              <div className="tech-value body-medium">Sinyal kaynağına bağlı, 50+ km</div>
            </div>
            <div className="tech-item">
              <div className="tech-label body-muted">Hedef Tipi</div>
              <div className="tech-value body-medium">Hava, kara ve deniz platformları</div>
            </div>
            <div className="tech-item">
              <div className="tech-label body-muted">Entegrasyon</div>
              <div className="tech-value body-medium">Mevcut hava savunma sistemleri</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Project;

